import Header from "../../../Components/Header/Header";
import Sidebar from "../../../Components/Sidebar/Sidebar";
import SewerageAssignCardManage from "./SewerageDashboardComponent/SewerageAssign/SewerageAssignCardManage";
import SewerageMaintainanceCardManage from "./SewerageDashboardComponent/SewerageMaintainance/SewerageMaintainanceCardManage";
import SewerageMasterCardManage from "./SewerageDashboardComponent/SewerageMaster/SewerageMasterCardManage";
import SeweragePreventiveCardManage from "./SewerageDashboardComponent/SeweragePreventive/SeweragePreventiveManage";
import SewerageServiceCardManage from "./SewerageDashboardComponent/SewerageService/SewerageServiceCardManage";
import { Pie } from 'react-chartjs-2';
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import MaintainanceManageCard from "./DashboardComponent/MaintainanceCard/MaintainanceManageCard";
import { WardNameDataDDL } from "../../../Components/CommonDDL/WardNameDataDDL";
import GardenMaintainanceCardManage from "./GarderDashboardComponent/GardenMaintainanceCard/GardenMaintainanceCardManage";
import { Pieoptions, ServicePieoptions } from "../../../Helper/Data";
import { useAuthState } from "../../../Helper/Context";
import { useDispatch, useSelector } from "react-redux";
import { SewerageDashMainCountDataAPI } from "../../../Redux/MainCountSlice/SewerageCount";
import { useSearchParams } from "react-router-dom";
import { Loading } from "../../../Helper/Loading";
import CommonDashboardWardNameDDL from "./CommonDashboardWardNameDDL";
import { SewerageButtonGroup } from "./GarderDashboardComponent/AllContain/SewerageButtonGroup";
import { SeverageOfficialVisitGrid } from "./SewerageDashboardComponent/SeverageOfficialVisitGrid/SeverageOfficialVisitGrid";
import GardenMaintainanceComp from "./GarderDashboardComponent/GardenMaintainanceCard/GardenMaintainanceComp";


export const SewerageDashboard = () => {

    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth  } = userDetails
    const { UserID, token, M_ProjectTypeID, RoleID } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")

    const [YearValue, setYearValue] = useState(null)
    const [YearLabel, setYearLabel] = useState(null)
    const [MonthValue, setMonthValue] = useState(null)
    const [MonthLabel, setMonthLabel] = useState(null)
    const [WardValue, setWardValue] = useState(null)
    const [WardLabel, setWardLabel] = useState(null)
    const [ActiveBtn, SetActiveBtn] = useState(RoleID == 2 ? "SeW Official Visit" : '')

    const [FinancialYear, setFinancialYear] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    // const [Month, setMonth] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select...",

    // })
    const [WardName, setWardName] = useState({
        DDL: [],
        ID: 1,
        Label: "Select",
    })

    const [Countdata, setCountdata] = useState('')
    const [From, set] = useState('')

    useEffect(() => {
        const data = {
            M_FinancialYearID: year.ID,
            M_WardID: Ward.ID,
            M_MonthID: Month.ID,
            M_UserID: UserID,
            Flag: 'Web',
            token: token,
            handleGetCount: handleGetCount
        }
        if (WardValue) {
            dispatch(SewerageDashMainCountDataAPI({ data }))
        }
    }, [Ward.ID,Month.ID,year.ID,WardValue])

    const { SewerageDashCountData, isLoading } = useSelector(state => state.SewerageDashMainCountData)

    const handleGetCount = (data) => {
        let tempData = {}
        data.forEach((item) => {
            tempData[item.paramName] = item.totalCount
        })
        setCountdata(tempData)
    }
    return (
        <div>
            {isLoading && <Loading />}
            <Header
                DashboardHeading="Sewerage Maintenance"
                setYearValue={setYearValue}
                setMonthValue={setMonthValue}
                FinancialYear={FinancialYear}
                setFinancialYear={setFinancialYear}
                Month={Month}
                setMonth={setMonth}
                setYearLabel={setYearLabel}
                setMonthLabel={setMonthLabel}
                setWardValue={setWardValue}
                setWardLabel={setWardLabel}
                DashboardName={DashboardName}
                HideYearMonthDDL='Dashboard'
                Name="Sewerage"
            />
            <div className="wrapper">
                <Sidebar
                    ProjectTypeId={ProjectTypeId}
                    DashProjectTypeId={DashProjectTypeId}
                    listActive="gardennn"
                    /> 
                    
                <div className="content1 content">
                    <CommonDashboardWardNameDDL
                        setWardValue={setWardValue}
                        setWardLabel={setWardLabel}
                    />
                    {/* <div className="mb-4 m-1 py-2 px-3 master_border" style={{ borderRadius: "15px"}}>
                    <GardenMaintainanceCardManage />
                    </div> */}
                        
                        {
                            RoleID == '1' &&
                            <GardenMaintainanceComp />
                        }

                    {
                        (M_ProjectTypeID == 0 && RoleID == 2) &&
                        <div className=" m-1 p-0 pt-2">
                            <SewerageButtonGroup
                                ActiveBtn={ActiveBtn}
                                SetActiveBtn={SetActiveBtn}
                            />
                        </div>
                    }

                    {/* {
                        ((M_ProjectTypeID == 0)) 
                    } */}
                    {
                        ActiveBtn == "SeW Official Visit" ?
                        <div className="m-1 p-0  mt-3">
                            <SeverageOfficialVisitGrid
                                FinancialYear={FinancialYear?.ID}
                                Month={Month?.ID}
                                M_WardID={WardValue}
                                AssetID='0'
                            />
                        </div>
                        :
                    <>
                        <div className="m-1 py-2 pb-4 master_border">
                            <SewerageMasterCardManage
                                Countdata={Countdata}
                                YearValue={YearValue}
                                YearLabel={YearLabel}
                                MonthValue={MonthValue}
                                MonthLabel={MonthLabel}
                                WardValue={WardValue}
                                WardLabel={WardLabel}
                                ProjectTypeId={ProjectTypeId}
                                DashboardName={DashboardName} />
                        </div>

                        <div className="row mt-4 m-1 py-2 pb-2 master_border">
                            <SeweragePreventiveCardManage
                                Countdata={Countdata}
                                YearValue={YearValue}
                                YearLabel={YearLabel}
                                MonthValue={MonthValue}
                                MonthLabel={MonthLabel}
                                WardValue={WardValue}
                                WardLabel={WardLabel}
                                ProjectTypeId={ProjectTypeId}
                                DashboardName={DashboardName} />
                        </div>

                        {/* <!--  --> */}

                        <div className="row mt-4 m-1 py-2 pb-2 master_border">
                            <SewerageServiceCardManage
                                Countdata={Countdata}
                                YearValue={YearValue}
                                YearLabel={YearLabel}
                                MonthValue={MonthValue}
                                MonthLabel={MonthLabel}
                                WardValue={WardValue}
                                WardLabel={WardLabel}
                                ProjectTypeId={ProjectTypeId}
                                DashboardName={DashboardName} />
                        </div>

                        {/* <div className="mt-4 m-1 py-2 pb-2 master_border">
                        
                            
                    </div> */}

                        {/* <!--  --> */}

                        <div className="row mt-4 mb-2 m-1 py-2 pb-2 master_border">

                            <div className="col-12 col-lg-12">
                                <SewerageAssignCardManage
                                    Countdata={Countdata}
                                    YearValue={YearValue}
                                    YearLabel={YearLabel}
                                    MonthValue={MonthValue}
                                    MonthLabel={MonthLabel}
                                    WardValue={WardValue}
                                    WardLabel={WardLabel}
                                    ProjectTypeId={ProjectTypeId}
                                    DashboardName={DashboardName} />
                            </div>

                        </div>
                    </>
                    }

                    {/* <!--  --> */}
                </div>
            </div>
            {/* <!-- [ Main Content ] end --> */}

        </div>
    )
}